export default __webpack_public_path__ + "static/media/meebits-logo-subpage.08a8bf98.webp";